import { useImperativeHandle, forwardRef, useEffect } from "react";
import { Col, Row, Button } from "react-bootstrap";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";

export default forwardRef(function Timer({ item, setBackgroundColor, setIsPlaying, isPlaying, time, setTime, getMeeting }, ref) {
  const url = process.env.REACT_APP_URL;
  const { user: authUser } = useSelector(x => x.auth);

  const isInitial = time === 0;
  const isLocked = false;
  // const intervalRef = useRef(null);

  // Play/Pause toggle
  const togglePlayPause = () => {
    setIsPlaying(prev => !prev);
  };

  // Stop handler
  const handleStop = async () => {
    setIsPlaying(false);
    // clearInterval(intervalRef.current); // Immediately stop the timer interval

    try {
      let timerData;
      // console.log('Saving time record:', time);
      if (item.timer) {
        // Timer exists, update it
        const updateResponse = await fetch(`${url}/timer/${item.agendaItemId}`, {
          method: 'PATCH',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${authUser.token}`,
          },
          body: JSON.stringify({
            event: item.agendaEvent.name,
            name: `${item.assignedUser?.firstName || 'TBA'} ${item.assignedUser?.lastName || ''}`,
            time: time, // Use the current time state
          }),
        });

        if (updateResponse.status === 200 || updateResponse.status === 201) {
          timerData = await updateResponse.json();
        } else {
          throw new Error('Failed to update time record');
        }
      } else {
        // Timer does not exist, create a new one
        const createResponse = await fetch(`${url}/timer/${item.agendaItemId}`, {
          method: 'PUT',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${authUser.token}`,
          },
          body: JSON.stringify({
            event: item.agendaEvent.name,
            name: `${item.assignedUser?.firstName || 'TBA'} ${item.assignedUser?.lastName || ''}`,
            time: time, // Use the current time state
          }),
        });

        if (createResponse.status === 200 || createResponse.status === 201) {
          timerData = await createResponse.json();
        } else {
          throw new Error('Failed to save time record');
        }
      }

      // Update the timer state with the saved data
      setTime(timerData.time);
    } catch (err) {
      toast.error('' + err, { position: 'bottom-left' });
    }
    getMeeting();
  };

  // Expose handleStop to parent via ref
  useImperativeHandle(ref, () => ({
    handleStop
  }));

  // Reset handler
  const handleReset = async () => {
    setIsPlaying(false);
    try {
      // Reset the timer on the server
      const response = await fetch(`${url}/timer/${item.agendaItemId}`, {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${authUser.token}`,
        },
      });

      if (response.status !== 200) {
        throw new Error('Failed to reset timer');
      }

    }
    catch (err) {
      toast.error('' + err, { position: 'bottom-left' });
    }

    setTime(0);
    setBackgroundColor("rgba(0, 0, 0, 0)");
    getMeeting();
  };

  // Timer interval effect
  // useEffect(() => {
  //   if (isPlaying) {
  //     intervalRef.current = setInterval(() => {
  //       setTime(prevTime => prevTime + 1);
  //     }, 1000);
  //   } else {
  //     clearInterval(intervalRef.current);
  //   }
  //   return () => clearInterval(intervalRef.current);
  // }, [isPlaying, setTime]);

  // Background color effect
  useEffect(() => {
    const { green, amber, red } = item?.agendaEvent || {};
    const convertToSeconds = (timeString) => {
      if (!timeString) return null;
      const [minutes, seconds] = timeString.split(':').map(Number);
      return minutes * 60 + seconds;
    };
    const greenTime = convertToSeconds(green);
    const amberTime = convertToSeconds(amber);
    const redTime = convertToSeconds(red);

    if (redTime !== null && time >= redTime) {
      setBackgroundColor("#dc3545"); // Red
    } else if (amberTime !== null && time >= amberTime) {
      setBackgroundColor("#ffc107"); // Amber
    } else if (greenTime !== null && time >= greenTime) {
      setBackgroundColor("#146c43"); // Green
    } else {
      setBackgroundColor("rgba(0, 0, 0, 0)");
    }
  }, [time, item?.agendaEvent, setBackgroundColor]);

  return (
    <Row className="mt-3 mb-5">
      <Col>
        {!isLocked && (
          <>
            {isPlaying ? (
              <Button variant="danger" className="me-2" onClick={handleStop} style={{ padding: '0 40px' }}>
                <i className="bi bi-stop-fill" style={{ fontSize: '40px' }}></i>
              </Button>
            ) : (
              <>
                {isInitial ? (
                  <Button variant="success" className="me-2" onClick={togglePlayPause} style={{ padding: '0 40px' }}>
                    <i className="bi bi-play-fill" style={{ fontSize: '40px' }}></i>
                  </Button>
                ) : (
                  <>
                    <Button variant="success" className="me-2" onClick={togglePlayPause} style={{ padding: '0 40px' }}>
                      <i className="bi bi-play-fill" style={{ fontSize: '40px' }}> </i>
                    </Button>
                    <Button variant="secondary" className='me-2' onClick={handleReset} style={{ padding: '0 40px' }}>
                      <i className='bi bi-arrow-clockwise' style={{ fontSize: '40px' }}></i>
                    </Button>
                  </>
                )}
              </>
            )}
          </>
        )}
      </Col>
    </Row>
  );
}
)